import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component, Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, SearchBox, Hits, Stats, ClearRefinements, useRefinementList, usePagination, useInstantSearch, Configure, Pagination } from 'react-instantsearch';
import { history } from 'instantsearch.js/es/lib/routers';
import debounce from 'lodash.debounce';
import { analyticsTrack } from '../../../analyticsUtils';
import filterImage from '../../../../assets/images/filter.png';
import filterGreen from '../../../../assets/images/filter-green.svg';
import xDark from '../../../../assets/images/x-dark-2.svg';
import x from '../../../../assets/images/x.svg';
import searchIcon from '../../../../assets/images/search-icon-white.svg';
import loading from '../../../../assets/images/spinner-DNA-2s-200px.svg';
import ExpertiseTagDropdown from '../../common/ExpertiseTagDropdown';
import { isMobile } from '../../../screenUtils';
import FilterItem from './FilterItem';
import EmptyFeaturedProfiles from '../../EmptyFeaturedProfiles';
import RecommendedConsultantCard from '../../RecommendedConsultantCard';
import './AlgoliaInstantSearch.scss';
var filterItems = [{
  title: 'Functional Areas',
  filterName: 'area_of_expertises.name'
}, {
  title: 'Role',
  filterName: 'higher_level_roles.name'
}, {
  title: 'Therapeutic Areas',
  filterName: 'therapeutic_areas.name'
}, {
  title: 'Product Technologies',
  filterName: 'therapies.name'
}, {
  title: 'Stages of Development',
  filterName: 'development_phases',
  checkbox: true
}, {
  title: 'Advanced Degree',
  filterName: 'degrees'
}, {
  title: 'Seniority',
  filterName: 'seniority_levels',
  checkbox: true
}, {
  title: 'Work Preference',
  filterName: 'role_types',
  checkbox: true
}, {
  title: 'Region',
  filterName: 'city',
  checkbox: true
}];
var truncate = function truncate(text, length) {
  return text.length > length ? "".concat(text.slice(0, length), "...") : text;
};
var processHit = function processHit(hit, csrfToken, handleRegister, getEmailStatus, indexName, cloraEmployer, projectResourceId, location, googleOmniauthUrl, msOmniauthUrl, signInUrl, onProjectSharePage, inviterId) {
  var _useInstantSearch = useInstantSearch(),
    uiState = _useInstantSearch.uiState;
  var filters = _objectSpread(_objectSpread({}, uiState[indexName].menu), uiState[indexName].refinementList);
  return /*#__PURE__*/React.createElement(RecommendedConsultantCard, {
    consultant: hit,
    location: location,
    csrfToken: csrfToken,
    idx: hit.position,
    handleRegister: handleRegister,
    getEmailStatus: getEmailStatus,
    filters: filters,
    cloraEmployer: cloraEmployer,
    projectResourceId: projectResourceId,
    googleOmniauthUrl: googleOmniauthUrl,
    msOmniauthUrl: msOmniauthUrl,
    signInUrl: signInUrl,
    onProjectSharePage: onProjectSharePage,
    inviterId: inviterId
  });
};
var transformItems = function transformItems(items) {
  return items.map(function (item, index) {
    return _objectSpread(_objectSpread({}, item), {}, {
      position: index
    });
  });
};
function LoadingIndicator() {
  var _useInstantSearch2 = useInstantSearch(),
    status = _useInstantSearch2.status;
  if (status === 'loading' || status === 'stalled') {
    return /*#__PURE__*/React.createElement("div", {
      className: "loading"
    }, /*#__PURE__*/React.createElement("img", {
      src: loading,
      alt: "Loading_image"
    }));
  }
  return null;
}
function SearchPagination(props) {
  var userData = props.userData;
  var _usePagination = usePagination(props),
    currentRefinement = _usePagination.currentRefinement,
    pages = _usePagination.pages;

  /* Using setTimeout to scroll to the top,
    as the Pagination component doesn't have any function we can use for that.
    Additionally, results are returned in milliseconds, which is why we set it to 1 second.
  */
  setTimeout(function () {
    window.scrollTo({
      top: 0
    });
  }, 1000);
  return [/*#__PURE__*/React.createElement("div", {
    key: "pagination",
    className: "centered-pagination"
  }, /*#__PURE__*/React.createElement(Pagination, {
    className: "pagination",
    showFirst: false,
    showLast: false,
    padding: isMobile() ? 1 : 3,
    translations: {
      previousPageItemText: '< Prev',
      nextPageItemText: 'Next >'
    }
  })), currentRefinement === pages.length - 1 ? /*#__PURE__*/React.createElement(EmptyFeaturedProfiles, {
    key: "empty",
    userData: userData
  }) : null];
}
function SearchErrorRefresh() {
  var _useInstantSearch3 = useInstantSearch(),
    addMiddlewares = _useInstantSearch3.addMiddlewares;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  useEffect(function () {
    var middleware = function middleware(_ref) {
      var instantSearchInstance = _ref.instantSearchInstance;
      function handleError(searchError) {
        setError(searchError);
      }
      return {
        subscribe: function subscribe() {
          instantSearchInstance.addListener('error', handleError);
        },
        unsubscribe: function unsubscribe() {
          instantSearchInstance.removeListener('error', handleError);
        }
      };
    };
    return addMiddlewares(middleware);
  }, [addMiddlewares]);
  if (!error) {
    return null;
  }
  window.location.reload();
}
function CustomCheckboxList(props) {
  var attribute = props.attribute;
  var _useRefinementList = useRefinementList(props),
    items = _useRefinementList.items,
    refine = _useRefinementList.refine;
  var transformedItems = _toConsumableArray(items);
  var attributeMappings = {
    seniority_levels: {
      Associate: 1,
      Manager: 2,
      Director: 3,
      'Vice President': 4,
      'C-Level': 5
    },
    development_phases: {
      Discovery: 1,
      'Pre-clinical': 2,
      'I/Exploratory': 3,
      'II/Proof of Concept': 4,
      'III/Pivotal': 5,
      'IV/Post-approval': 6,
      'Approved Product': 7,
      'CE Mark': 8
    }
  };
  if (attribute in attributeMappings) {
    var attributeMapping = attributeMappings[attribute];
    transformedItems = transformedItems.filter(function (item) {
      return Object.prototype.hasOwnProperty.call(attributeMapping, item.label);
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        sortValue: attributeMapping[item.label]
      });
    }).sort(function (a, b) {
      return a.sortValue - b.sortValue;
    });
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: "query-refinement"
  }, transformedItems.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.label
    }, /*#__PURE__*/React.createElement("label", {
      className: "custom-checkbox-container",
      htmlFor: item.value
    }, /*#__PURE__*/React.createElement("input", {
      id: item.value,
      name: item.value,
      type: "checkbox",
      className: "checkbox-box",
      checked: item.isRefined,
      onChange: function onChange() {
        return refine(item.value);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "checkmark"
    }), /*#__PURE__*/React.createElement("span", {
      className: "checkbox-text ".concat(item.isRefined ? 'active' : '')
    }, truncate(item.label, 30))));
  }));
}
CustomCheckboxList.propTypes = {
  attribute: PropTypes.string.isRequired
};
var filterPicklist = function filterPicklist(picklist, input) {
  return picklist.filter(function (record) {
    return record.label.toLowerCase().includes(input.toLowerCase());
  });
};
function SelectedRefinementTags(props) {
  var imageStyle = props.imageStyle;
  var _useRefinementList2 = useRefinementList(props),
    items = _useRefinementList2.items,
    refine = _useRefinementList2.refine;
  return items.filter(function (i) {
    return i.isRefined;
  }).map(function (item) {
    return /*#__PURE__*/React.createElement("button", {
      key: item.value,
      className: "selected-tag",
      onClick: function onClick() {
        return refine(item.value);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text"
    }, item.label), /*#__PURE__*/React.createElement("img", {
      src: imageStyle === 'green' ? x : xDark,
      className: "remove-tag",
      alt: "remove ".concat(item.label)
    }));
  });
}
function MobileShowConsultantsButton(props) {
  var toggleRefinePanel = props.toggleRefinePanel;
  var _useInstantSearch4 = useInstantSearch(),
    results = _useInstantSearch4.results;
  return /*#__PURE__*/React.createElement("button", {
    className: "mobile-show-consultants",
    onClick: toggleRefinePanel
  }, "Show ".concat(results.nbHits, " Consultants"));
}
MobileShowConsultantsButton.propTypes = {
  toggleRefinePanel: PropTypes.func
};
var filteredCount = function filteredCount() {
  var _useInstantSearch5 = useInstantSearch(),
    indexUiState = _useInstantSearch5.indexUiState;
  return indexUiState.refinementList ? filterItems.reduce(function (aggr, item) {
    return (indexUiState.refinementList[item.filterName] && indexUiState.refinementList[item.filterName].length || 0) + aggr;
  }, 0) : 0;
};
function ClearSelection(props) {
  var className = props.className;
  return filteredCount() > 0 && /*#__PURE__*/React.createElement(ClearRefinements, {
    className: className || 'clear-query',
    translations: {
      resetButtonText: 'Clear All'
    }
  });
}
function MobileRefinementStatus(props) {
  var toggleRefinePanel = props.toggleRefinePanel,
    showMenu = props.showMenu;
  return [/*#__PURE__*/React.createElement("button", {
    key: "toggle",
    className: "toggle-refine-panel ".concat(showMenu ? 'd-none' : ''),
    onClick: toggleRefinePanel
  }, /*#__PURE__*/React.createElement("img", {
    src: filterGreen,
    className: "me-3",
    alt: "funnel"
  }), "Refine Results", filteredCount > 0 ? " (".concat(filteredCount, ")") : ''), /*#__PURE__*/React.createElement("div", {
    key: "tags",
    className: "mobile-selected-tags ".concat(showMenu ? 'd-none' : '')
  }, filterItems.map(function (item) {
    return /*#__PURE__*/React.createElement(SelectedRefinementTags, {
      key: item.filterName,
      imageStyle: "white",
      attribute: item.filterName
    });
  }), /*#__PURE__*/React.createElement(ClearSelection, null))];
}
function SelectionSubtext(props) {
  return filteredCount() > 0 && /*#__PURE__*/React.createElement("div", {
    className: "selection-subtext"
  }, "Your keyword recommendations based on your project details. Tip: For more results, update", /*#__PURE__*/React.createElement("a", {
    href: "/projects/".concat(props.projectResourceId, "/edit")
  }, " Project Details "), "or try different filters.");
}
function CustomMenu(props) {
  var model = props.model,
    title = props.title,
    _handleSelect = props.handleSelect;
  var _useRefinementList3 = useRefinementList(props),
    items = _useRefinementList3.items,
    refine = _useRefinementList3.refine,
    canRefine = _useRefinementList3.canRefine;
  var transformedItems = _toConsumableArray(items);
  if (model === 'degrees') {
    var validDegrees = ['MD (Doctor of Medicine)', 'MPH (Master of Public Health)', 'MBA (Master of Business Administration)', 'PharmD (Doctor of Pharmacy)', 'PhD (Doctor of Philosophy)'];
    transformedItems = transformedItems.filter(function (item) {
      return validDegrees.includes(item.label);
    });
  }
  return /*#__PURE__*/React.createElement(ExpertiseTagDropdown, {
    model: model,
    selection: transformedItems.filter(function (i) {
      return i.isRefined;
    }).map(function (item) {
      return {
        label: truncate(item.label, 25),
        value: item.value
      };
    }),
    handleSelect: function handleSelect() {
      return _handleSelect(refine);
    },
    handleRemove: function handleRemove(value) {
      return refine(value);
    },
    heading: title,
    menuHeading: "Select ".concat(title),
    isDisabled: !canRefine,
    picklist: transformedItems,
    loadOptions: function loadOptions(input) {
      return new Promise(function (resolve) {
        resolve(filterPicklist(transformedItems, input));
      });
    },
    showSubHeading: false,
    showMenuFooter: false,
    ctaVerb: "Select ",
    bodyClass: "",
    plusColor: "alt",
    multi: true
  });
}
CustomMenu.propTypes = {
  model: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired
};
var transformFilters = function transformFilters(state) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'url';
  var transformedFilters = {};
  var filters = {
    aoes: 'area_of_expertises.name',
    tas: 'therapeutic_areas.name',
    therapies: 'therapies.name',
    development_phases: 'development_phases',
    roles: 'seniority_levels',
    regions: 'city',
    educations: 'degrees',
    hlrs: 'higher_level_roles.name',
    work_preference: 'role_types'
  };
  Object.entries(filters).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    var transformedKey = format === 'url' ? value : key;
    if (Object.prototype.hasOwnProperty.call(state, transformedKey)) {
      var stateKey = format === 'url' ? key : value;
      transformedFilters[stateKey] = state[transformedKey];
    }
  });
  return transformedFilters;
};
var routing = function routing(indexName) {
  return {
    router: history(),
    stateMapping: {
      stateToRoute: function stateToRoute(uiState) {
        var indexUiState = uiState[indexName];
        var urlFilters = {};
        if (indexUiState && indexUiState.refinementList) {
          urlFilters = transformFilters(indexUiState.refinementList);
        }
        return _objectSpread({
          q: indexUiState.query,
          page: indexUiState.page
        }, urlFilters);
      },
      routeToState: function routeToState(routeState) {
        var algoliaFilters = {};
        if (Object.keys(routeState).length > 0) {
          algoliaFilters = transformFilters(routeState, 'algolia');
        }
        return _defineProperty({}, indexName, {
          query: routeState.q,
          page: routeState.page,
          refinementList: algoliaFilters
        });
      }
    }
  };
};
var renderStats = function renderStats(className) {
  return /*#__PURE__*/React.createElement("div", {
    className: "stats-container  mb-3  ".concat(className)
  }, /*#__PURE__*/React.createElement(Stats, {
    translations: {
      rootElementText: function rootElementText(_ref5) {
        var nbHits = _ref5.nbHits;
        return "".concat(nbHits, " consultants you can connect with");
      }
    }
  }));
};
var reportSearchToSegment = debounce(function (filters, query, numResults, location) {
  var filtersLen = Object.values(filters).reduce(function (aggr, val) {
    return aggr + val.length;
  }, 0);
  if (filtersLen > 0 || query && query.length) {
    analyticsTrack('performedSearch', {
      location: location,
      properties: {
        facets: filters,
        queryString: query,
        numResults: numResults
      }
    });
  }
}, 1000);
function SegmentReporter(props) {
  var _useInstantSearch6 = useInstantSearch(),
    results = _useInstantSearch6.results,
    indexUiState = _useInstantSearch6.indexUiState;
  var location = props.location;
  var filters = _objectSpread(_objectSpread({}, indexUiState.menu), indexUiState.refinementList);
  var query = indexUiState && indexUiState.query;
  reportSearchToSegment(filters, query, results.nbHits, location);
  return null;
}
var hitsPerPage = function hitsPerPage(onProjectSharePage) {
  if (onProjectSharePage) return 1;
  return isMobile() ? 5 : 20;
};
var AlgoliaInstantSearch = /*#__PURE__*/function (_Component) {
  function AlgoliaInstantSearch(props) {
    var _this;
    _classCallCheck(this, AlgoliaInstantSearch);
    _this = _callSuper(this, AlgoliaInstantSearch, [props]);
    _this.state = {
      showMenu: !isMobile() || props.onProjectSharePage,
      searchClient: algoliasearch(props.agAppID, props.publicKey)
    };
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.toggleRefinePanel = _this.toggleRefinePanel.bind(_this);
    _this.renderHit = _this.renderHit.bind(_this);
    return _this;
  }
  _inherits(AlgoliaInstantSearch, _Component);
  return _createClass(AlgoliaInstantSearch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        agAppID = _this$props.agAppID,
        publicKey = _this$props.publicKey;
      if (prevProps.agAppID !== agAppID || prevProps.publicKey !== publicKey) {
        this.setState({
          searchClient: algoliasearch(agAppID, publicKey)
        });
      }
    }

    // Bound once so react-instantsearch's <Hits hitComponent={...}> keeps a stable
    // component identity across re-renders. Passing a fresh inline arrow function here
    // instead makes React treat every hit as a brand-new component type on each render,
    // unmounting and remounting every card — which can silently swallow a click that's
    // in flight when a re-render happens (e.g. from a sibling card's async state update).
  }, {
    key: "renderHit",
    value: function renderHit(_ref6) {
      var hit = _ref6.hit;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        handleRegister = _this$props2.handleRegister,
        getEmailStatus = _this$props2.getEmailStatus,
        indexName = _this$props2.indexName,
        cloraEmployer = _this$props2.cloraEmployer,
        projectResourceId = _this$props2.projectResourceId,
        location = _this$props2.location,
        googleOmniauthUrl = _this$props2.googleOmniauthUrl,
        msOmniauthUrl = _this$props2.msOmniauthUrl,
        signInUrl = _this$props2.signInUrl,
        onProjectSharePage = _this$props2.onProjectSharePage,
        inviterId = _this$props2.inviterId;
      return processHit(hit, csrfToken, handleRegister, getEmailStatus, indexName, cloraEmployer, projectResourceId, location, googleOmniauthUrl, msOmniauthUrl, signInUrl, onProjectSharePage, inviterId);
    }
  }, {
    key: "toggleRefinePanel",
    value: function toggleRefinePanel() {
      var showMenu = this.state.showMenu;
      this.setState({
        showMenu: !showMenu
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(refine) {
      return function (tags) {
        if (tags && tags.length) {
          var unrefinedTag = tags.find(function (tag) {
            return tag.isRefined === false;
          });
          if (unrefinedTag) {
            refine(unrefinedTag.value);
            return true;
          }
          return false;
        }
        // Don't call refine() without a value - this would cause the toggleRefinement error
        return false;
      };
    }
  }, {
    key: "renderFilterItems",
    value: function renderFilterItems() {
      var _this2 = this;
      return filterItems.map(function (item) {
        return item.checkbox ? /*#__PURE__*/React.createElement(FilterItem, {
          filterTitle: item.title,
          key: item.filterName
        }, /*#__PURE__*/React.createElement(CustomCheckboxList, {
          attribute: item.filterName,
          sortBy: ['name']
        })) : /*#__PURE__*/React.createElement(CustomMenu, {
          key: item.filterName,
          model: item.filterName,
          attribute: item.filterName,
          title: item.title,
          filterName: item.filterName,
          handleSelect: _this2.handleSelect,
          limit: 100,
          sortBy: ['name']
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        indexName = _this$props3.indexName,
        userData = _this$props3.userData,
        projectResourceId = _this$props3.projectResourceId,
        initialFilters = _this$props3.initialFilters,
        location = _this$props3.location,
        onProjectSharePage = _this$props3.onProjectSharePage;
      var _this$state = this.state,
        searchClient = _this$state.searchClient,
        showMenu = _this$state.showMenu;
      return /*#__PURE__*/React.createElement(InstantSearch, {
        indexName: indexName,
        searchClient: searchClient,
        routing: initialFilters ? null : routing(indexName),
        initialUiState: _defineProperty({}, indexName, initialFilters)
      }, /*#__PURE__*/React.createElement(Configure, {
        hitsPerPage: hitsPerPage(onProjectSharePage)
      }), /*#__PURE__*/React.createElement("div", {
        className: "instant-search-container"
      }, /*#__PURE__*/React.createElement(SegmentReporter, {
        location: location
      }), onProjectSharePage ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(LoadingIndicator, null), /*#__PURE__*/React.createElement(Hits, {
        hitComponent: this.renderHit,
        transformItems: transformItems,
        classNames: {
          list: 'rec-card-container'
        }
      })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "search-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-header-text"
      }, "Find Top Consultants"), /*#__PURE__*/React.createElement("div", {
        className: "project-recommended-tab-stats"
      }, /*#__PURE__*/React.createElement("div", {
        className: "recommended-consultants"
      }, "Recommended Consultants"), /*#__PURE__*/React.createElement("div", {
        className: "stats"
      }, renderStats('stats-left'))), /*#__PURE__*/React.createElement("div", {
        className: "search-input"
      }, /*#__PURE__*/React.createElement(SearchBox, {
        placeholder: "Search Ex: Clinical Operations Consultants",
        submitIconComponent: function submitIconComponent() {
          return /*#__PURE__*/React.createElement("img", {
            src: searchIcon,
            alt: "magnifying glass"
          });
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "search-result-container"
      }, /*#__PURE__*/React.createElement(MobileRefinementStatus, {
        toggleRefinePanel: this.toggleRefinePanel,
        showMenu: showMenu
      }), /*#__PURE__*/React.createElement("div", {
        className: "left-panel ".concat(showMenu ? '' : 'd-none')
      }, /*#__PURE__*/React.createElement("div", {
        className: "left-panel-header"
      }, "Refine Results", /*#__PURE__*/React.createElement("img", {
        alt: "funnel",
        src: filterImage,
        className: "ms-2 filter-image"
      }), /*#__PURE__*/React.createElement("button", {
        onClick: this.toggleRefinePanel,
        className: "close-refine-panel"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Close Panel",
        src: xDark
      }))), this.renderFilterItems(), /*#__PURE__*/React.createElement(MobileShowConsultantsButton, {
        toggleRefinePanel: this.toggleRefinePanel
      }), /*#__PURE__*/React.createElement(ClearSelection, null)), renderStats('stats-left'), /*#__PURE__*/React.createElement("div", {
        className: "right-panel"
      }, /*#__PURE__*/React.createElement(LoadingIndicator, null), /*#__PURE__*/React.createElement("div", {
        className: "selected-tags"
      }, filterItems.map(function (item) {
        return /*#__PURE__*/React.createElement(SelectedRefinementTags, {
          key: item.filterName,
          imageStyle: "green",
          attribute: item.filterName
        });
      }), /*#__PURE__*/React.createElement(ClearSelection, null), projectResourceId && /*#__PURE__*/React.createElement(SelectionSubtext, {
        projectResourceId: projectResourceId
      })), renderStats('stats-right'), /*#__PURE__*/React.createElement(Hits, {
        hitComponent: this.renderHit,
        transformItems: transformItems,
        classNames: {
          list: 'rec-card-container'
        }
      }), /*#__PURE__*/React.createElement(SearchErrorRefresh, null), /*#__PURE__*/React.createElement(SearchPagination, {
        userData: userData
      }))))));
    }
  }]);
}(Component);
AlgoliaInstantSearch.propTypes = {
  indexName: PropTypes.string.isRequired,
  agAppID: PropTypes.string.isRequired,
  publicKey: PropTypes.string.isRequired,
  handleRegister: PropTypes.func,
  getEmailStatus: PropTypes.func,
  userData: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  cloraEmployer: PropTypes.bool,
  initialFilters: PropTypes.shape({}),
  projectResourceId: PropTypes.string,
  location: PropTypes.string,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  signInUrl: PropTypes.string,
  onProjectSharePage: PropTypes.bool,
  inviterId: PropTypes.string
};
AlgoliaInstantSearch.defaultProps = {
  handleRegister: function handleRegister() {},
  getEmailStatus: function getEmailStatus() {
    return null;
  },
  cloraEmployer: false,
  initialFilters: null,
  projectResourceId: null,
  location: 'Featured Page',
  onProjectSharePage: false,
  inviterId: null,
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  signInUrl: null
};
export default AlgoliaInstantSearch;